var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.55556C0 0.696446 0.716344 0 1.6 0H14.4C15.2837 0 16 0.696446 16 1.55556V12.4444C16 13.3036 15.2837 14 14.4 14H1.6C0.716345 14 0 13.3036 0 12.4444V1.55556ZM14.4 1.55556H1.6V3.88889H14.4V1.55556ZM4.8 5.44444H1.6V8.16667H4.8V5.44444ZM4.8 9.72222H1.6V12.4444H4.8V9.72222ZM6.4 5.44444H9.6V8.16667H6.4V5.44444ZM9.6 9.72222H6.4V12.4444H9.6V9.72222ZM11.2 5.44444H14.4V8.16667H11.2V5.44444ZM14.4 9.72222H11.2V12.4444H14.4V9.72222Z",
    fill: "#1F85CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.4ed902af1967822bafba0dcfaf74a91b.svg";
export { ForwardRef as ReactComponent };